import { useEffect } from "react";
import { IoEyeSharp } from 'react-icons/io5'
import { Button } from "antd";
import { Link } from 'react-router-dom'
import { AiFillSetting } from 'react-icons/ai' 
import TableControl from "../../component/table/TableControl";

export default function StationTableStations(props) {
  
  useEffect(() => {

  }, []);

  const getStationStatus = (code) =>{
    if(code == 0){ return <div style={{color: '#3D3D3D', fontWeight: "bold"}}>ปิดใช้งาน</div>
      }else if(code == 1){ return <div style={{color: '#85e700', fontWeight: "bold"}}>เปิดใช้งาน</div>
      }else{ return <div style={{color: '#FFD02B', fontWeight: "bold"}}>ไม่พบสถานะ</div>}
  }

  const column = [
    { title: "จังหวัด", dataIndex: "province", align: "center", className: "cn allow-search", sorter: (a, b) => a.province.localeCompare(b.province), },
    { title: "สถานี", dataIndex: "name_th", align: "center", className: "cn allow-search", sorter: (a, b) => a.name_th.localeCompare(b.name_th), },
    { title: "สถานะ", dataIndex: "status", align: "center", className: "cn",  sorter: (a, b) => a.status - b.status, 
      render: (_, record) => (
        <>
          {getStationStatus(record.status)}
        </>
      ),
    },
    { title: <AiFillSetting/>, dataIndex: "graph", align: "center", width: 40, className:"cell-graph", 
    render: (_, record) => (
      <>
         <Link to={'/stations/'+record.id}><Button><IoEyeSharp style={{color: "#006994"}}/></Button></Link>
      </>
    ),
    },
  ];

  return (
    <TableControl
      className={
        "table-list-station" +
        (props.className ? props.className : "")
      }
      rowKey={'id'}
      data={props.data}
      columns={column}
      dataSet={1}
    />
  );
}

